/* tslint:disable:max-line-length */

import { Injectable, NgZone } from '@angular/core';
import {FormArray, FormControl, FormGroup, Validators} from '@angular/forms';
import {  Observable } from 'rxjs';
import { ResiduService } from '../../../controllers/Residu';
import * as __model from '../../../model';
import { APIConfigService } from '../../../apiconfig.service';

import * as __utils from '../../../yasag-utils';

import { YASAGPostFormService } from '../../yasag-post.service';


@Injectable()
export class ResiduUpdateFormService extends YASAGPostFormService<__model.Residu> {
  static xImiRoles = {"admin":"administrator can use this endpoint"};
  form = new FormGroup({
    data: new FormGroup({
      codi_residu: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(12)]),
      residu_mare: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(512), Validators.minLength(1), Validators.required]),
      titol_ca: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(512), Validators.minLength(1), Validators.required]),
      titol_es: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(512), Validators.minLength(1), Validators.required]),
      titol_en: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(512), Validators.minLength(1), Validators.required]),
      descripcio_ca: new FormControl({value: undefined, disabled: false}, [Validators.minLength(1), Validators.required]),
      descripcio_es: new FormControl({value: undefined, disabled: false}, [Validators.minLength(1), Validators.required]),
      descripcio_en: new FormControl({value: undefined, disabled: false}, [Validators.minLength(1), Validators.required]),
      descripcio_adicional_ca: new FormControl({value: undefined, disabled: false}, []),
      descripcio_adicional_es: new FormControl({value: undefined, disabled: false}, []),
      descripcio_adicional_en: new FormControl({value: undefined, disabled: false}, []),
      alt_ca: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(512)]),
      alt_es: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(512)]),
      alt_en: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(512)]),
      especial: new FormControl({value: undefined, disabled: false}, []),
      fraccions: new FormArray([], [Validators.required]),
      categories: new FormControl([], []),
      informacio_secundaria: new FormControl([], []),
      sinonims: new FormArray([], []),
    }, [Validators.required]),
    fields: new FormControl({value: undefined, disabled: false}, []),
    expand: new FormControl({value: undefined, disabled: false}, []),
    codi_residu: new FormControl({value: undefined, disabled: false}, [Validators.required]),
  });
  constructor(
    apiConfigService: APIConfigService,
    ngZone: NgZone,
    private service: ResiduService,
  ) {
    super('ResiduUpdate', apiConfigService, ngZone);
    this.init();
  }

  public addDataFraccions( fraccions: number = 1, position?: number, value?: any): void {
    const control = <FormArray>this.form['controls']['data']['controls']['fraccions'];
    const fg = new FormGroup({
      fraccio: new FormControl({value: undefined, disabled: false}, [Validators.required]),
      prioritat: new FormControl({value: undefined, disabled: false}, [Validators.max(999999997)]),
    }, []);
    __utils.addField(control,fraccions, fg, position, value);
  }

  public removeDataFraccions( i: number): void {
    const control = <FormArray>this.form['controls']['data']['controls']['fraccions'];
    control.removeAt(i);
  }

  public addDataSinonims( sinonims: number = 1, position?: number, value?: any): void {
    const control = <FormArray>this.form['controls']['data']['controls']['sinonims'];
    const fg = new FormGroup({
      id: new FormControl({value: undefined, disabled: false}, []),
      sinonim_ca: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(512)]),
      sinonim_es: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(512)]),
      sinonim_en: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(512)]),
      sinonim_fals: new FormControl({value: undefined, disabled: false}, []),
      residu: new FormControl({value: undefined, disabled: false}, [Validators.required]),
    }, []);
    __utils.addField(control,sinonims, fg, position, value);
  }

  public removeDataSinonims( i: number): void {
    const control = <FormArray>this.form['controls']['data']['controls']['sinonims'];
    control.removeAt(i);
  }

  submit(value: typeof this.form.value | false = false): Observable<__model.Residu> {
    const result = val => this.service.update(val);
    return this._submit('__model.Residu', result, 'null', value, false );
  }
  listen(value: typeof this.form.value | false = false, submit: boolean = true): Observable<__model.Residu> {
    if (submit) {
      this.submit(value);
    }
    return this._listen(value, submit);
  }


  reset(value?: typeof this.form.value): void {
    this.form.reset();
    while ((<FormArray>this.form['controls']['data']['controls']['fraccions']).length) {
      this.removeDataFraccions(0);
    }
    if (value && value['data'] && value['data']['fraccions']) {
      this.addDataFraccions(value['data']['fraccions'].length);
    }
    while ((<FormArray>this.form['controls']['data']['controls']['sinonims']).length) {
      this.removeDataSinonims(0);
    }
    if (value && value['data'] && value['data']['sinonims']) {
      this.addDataSinonims(value['data']['sinonims'].length);
    }
    super.reset(value, false); 
  }
  patch(value: typeof this.form.value): void {
    if (value && value['data'] && value['data']['fraccions']) {
      while (this.form.value['data']['fraccions'].length > 0) {
        this.removeDataFraccions(0);
      }
      if (value['data']['fraccions'].length > this.form.value['data']['fraccions'].length) {
        this.addDataFraccions(value['data']['fraccions'].length - this.form.value['data']['fraccions'].length);
      }
    }
    if (value && value['data'] && value['data']['sinonims']) {
      while (this.form.value['data']['sinonims'].length > 0) {
        this.removeDataSinonims(0);
      }
      if (value['data']['sinonims'].length > this.form.value['data']['sinonims'].length) {
        this.addDataSinonims(value['data']['sinonims'].length - this.form.value['data']['sinonims'].length);
      }
    }
    this.form.patchValue(value);
  }
}
